// Vapor95 contact page: an early-2000s office (Blender render). Click the CRT to zoom in and write us an email
// (a real Shopify contact form dressed as Outlook Express); the folders open FAQ / Privacy / Terms as memos;
// the desk phone is the order status hotline. Scene data (screen corners, click outlines) comes from
// blender/build_office.py via tools/build_site.py -> window.V95_OFFICE_DATA.
(function (g) {
  "use strict";
  const DATA = g.V95_OFFICE_DATA;
  const root = document.querySelector("[data-v95-office]");
  if (!root || !DATA) return;
  const SW = 640, SH = 480;
  const LABELS = { faq: "FAQ", privacy: "Privacy Policy", terms: "Terms of Service", phone: "Track your order", screen: "Email us" };

  const stage = root.querySelector(".v95o-stage");
  const screen = root.querySelector(".v95o-screen");
  const tip = root.querySelector(".v95o-tip");
  let variant = null, zoomed = false, base = null;

  // ------------------------------------------------------------------ geometry
  // CSS matrix3d that maps the 640x480 screen box onto the CRT's four corners (TL, TR, BR, BL) in the render
  function homography(c) {
    const [[x0, y0], [x1, y1], [x2, y2], [x3, y3]] = c;
    const dx1 = x1 - x2, dx2 = x3 - x2, dy1 = y1 - y2, dy2 = y3 - y2;
    const sx = x0 - x1 + x2 - x3, sy = y0 - y1 + y2 - y3;
    const den = dx1 * dy2 - dx2 * dy1;
    const g_ = (sx * dy2 - dx2 * sy) / den, h = (dx1 * sy - sx * dy1) / den;
    const a = x1 - x0 + g_ * x1, b = x3 - x0 + h * x3, d = y1 - y0 + g_ * y1, e = y3 - y0 + h * y3;
    // unit square -> quad, then scale the 640x480 box down to the unit square
    const m = [a / SW, d / SW, 0, g_ / SW, b / SH, e / SH, 0, h / SH, 0, 0, 1, 0, x0, y0, 0, 1];
    return "matrix3d(" + m.map((v) => +v.toFixed(10)).join(",") + ")";
  }
  function bbox(pts) {
    const xs = pts.map((p) => p[0]), ys = pts.map((p) => p[1]);
    return { x: Math.min(...xs), y: Math.min(...ys), w: Math.max(...xs) - Math.min(...xs), h: Math.max(...ys) - Math.min(...ys) };
  }

  // ------------------------------------------------------------------ build the stage for the current shape of the window
  function pickVariant() {
    const portrait = root.clientWidth / root.clientHeight < 0.95 && DATA.portrait;
    return portrait ? DATA.portrait : DATA.wide;
  }
  // fill the window below the store header (the theme header sits above this section)
  function fitHeight() {
    const top = root.getBoundingClientRect().top + g.scrollY;
    const h = Math.max(420, (g.visualViewport ? g.visualViewport.height : g.innerHeight) - top);
    if (top > 0 && top < 300) root.style.height = h + "px";
  }
  function build() {
    fitHeight();
    const v = pickVariant();
    if (v === variant) { place(true); return; }
    variant = v;
    stage.style.width = v.w + "px"; stage.style.height = v.h + "px";
    stage.querySelector(".v95o-wide").src = v.img;
    stage.querySelector(".v95o-wide").style.cssText = `left:0;top:0;width:${v.w}px;height:${v.h}px`;
    const cu = stage.querySelector(".v95o-closeup");
    cu.classList.remove("is-loaded");
    if (v.closeup) {
      cu.style.cssText = `left:${v.closeup.x}px;top:${v.closeup.y}px;width:${v.closeup.w}px;height:${v.closeup.h}px`;
      cu.onload = () => cu.classList.add("is-loaded");
      // fetch the sharp close-up once the page is idle (or right away when someone heads for the screen)
      const load = () => { if (!cu.getAttribute("src")) cu.src = v.closeup.img; };
      if (g.requestIdleCallback) g.requestIdleCallback(load, { timeout: 1500 }); else setTimeout(load, 1500);
      root._loadCloseup = load;
    }
    screen.style.transform = homography(v.screen);
    const svg = stage.querySelector(".v95o-hits");
    svg.setAttribute("width", v.w); svg.setAttribute("height", v.h); svg.setAttribute("viewBox", `0 0 ${v.w} ${v.h}`);
    svg.innerHTML = "";
    for (const key of ["phone", "terms", "privacy", "faq"]) {
      if (!v.hits[key]) continue;
      const p = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
      p.setAttribute("points", v.hits[key].map((q) => q.join(",")).join(" "));
      p.setAttribute("tabindex", "0"); p.setAttribute("role", "button"); p.setAttribute("aria-label", LABELS[key]);
      p.dataset.key = key;
      svg.appendChild(p);
    }
    place(true);
  }

  // cover the viewport, keeping the desk (focus) in view
  function coverTransform() {
    const v = variant, W = root.clientWidth, H = root.clientHeight;
    const k = Math.max(W / v.w, H / v.h);
    let tx = W / 2 - v.focus[0] * k, ty = H / 2 - v.focus[1] * k;
    tx = Math.min(0, Math.max(W - v.w * k, tx)); ty = Math.min(0, Math.max(H - v.h * k, ty));
    return { k, tx, ty };
  }
  // fill the viewport with the CRT screen (a little of the bezel showing)
  function zoomTransform() {
    const W = root.clientWidth, H = root.clientHeight, b = bbox(variant.screen);
    const pad = W < 750 ? 1.04 : 1.14;
    const k = Math.min(W / (b.w * pad), H / (b.h * pad));
    return { k, tx: W / 2 - (b.x + b.w / 2) * k, ty: H / 2 - (b.y + b.h / 2) * k };
  }
  function apply(t, instant) {
    stage.classList.toggle("is-instant", !!instant);
    stage.style.transform = `translate(${t.tx}px, ${t.ty}px) scale(${t.k})`;
    if (instant) { stage.offsetWidth; stage.classList.remove("is-instant"); }
  }
  function place(instant) { base = coverTransform(); apply(zoomed ? zoomTransform() : base, instant); }

  // ------------------------------------------------------------------ zoom in / out of the computer
  const mail = root.querySelector(".v95o-mail"), dialogEl = root.querySelector(".v95o-dialog");
  const mailHome = mail.parentNode;
  const small = () => root.clientWidth < 750;
  let maxTimer = 0;
  function maximize(on) {
    clearTimeout(maxTimer);
    if (on) {
      root.appendChild(mail); root.appendChild(dialogEl);
      mail.classList.add("is-max"); dialogEl.classList.add("is-max");
    } else if (mail.classList.contains("is-max")) {
      mail.classList.remove("is-max"); dialogEl.classList.remove("is-max");
      mailHome.appendChild(mail); mailHome.appendChild(dialogEl);
    }
  }
  function zoomIn() {
    if (zoomed) return;
    if (root._loadCloseup) root._loadCloseup();
    zoomed = true;
    root.classList.add("is-zoomed");
    apply(zoomTransform());
    hideTip();
    if (small()) maxTimer = setTimeout(() => maximize(true), 1050);
    setTimeout(() => { const f = root.querySelector(".v95o-mail [data-first]"); if (f && !isTouch()) f.focus({ preventScroll: true }); }, 1200);
  }
  function zoomOut() {
    if (!zoomed) return;
    zoomed = false;
    maximize(false);
    root.classList.remove("is-zoomed");
    apply(base);
  }
  const isTouch = () => g.matchMedia("(pointer: coarse)").matches;
  screen.addEventListener("click", () => { if (!zoomed) zoomIn(); });
  root.querySelector(".v95o-back").addEventListener("click", zoomOut);
  root.querySelectorAll("[data-zoom-out]").forEach((b) => b.addEventListener("click", zoomOut));
  g.addEventListener("keydown", (e) => { if (e.key === "Escape") { if (openModal) closeModal(); else zoomOut(); } });
  g.addEventListener("resize", () => build());
  // focusing a field must never scroll the scene sideways (older browsers without overflow: clip)
  root.addEventListener("scroll", () => { if (root.scrollLeft || root.scrollTop) { root.scrollLeft = 0; root.scrollTop = 0; } });

  // ------------------------------------------------------------------ hotspots: hover label + click
  function showTip(key, x, y) {
    tip.textContent = LABELS[key];
    const r = root.getBoundingClientRect();
    tip.style.left = x - r.left + "px"; tip.style.top = y - r.top + "px";
    tip.classList.add("is-on");
  }
  function hideTip() { tip.classList.remove("is-on"); }
  const svg = stage.querySelector(".v95o-hits");
  svg.addEventListener("pointermove", (e) => { const k = e.target.dataset && e.target.dataset.key; if (k && !isTouch()) showTip(k, e.clientX, e.clientY); else hideTip(); });
  svg.addEventListener("pointerleave", hideTip);
  svg.addEventListener("click", (e) => { const k = e.target.dataset && e.target.dataset.key; if (k) open(k); });
  svg.addEventListener("keydown", (e) => { const k = e.target.dataset && e.target.dataset.key; if (k && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); open(k); } });
  screen.addEventListener("pointermove", (e) => { if (!zoomed && !isTouch()) showTip("screen", e.clientX, e.clientY); });
  screen.addEventListener("pointerleave", hideTip);

  // ------------------------------------------------------------------ folders (memos) + phone (order hotline)
  let openModal = null;
  function open(key) {
    hideTip();
    const m = document.getElementById(key === "phone" ? "v95o-phone" : "v95o-memo");
    if (key !== "phone") fillMemo(key);
    m.classList.add("is-on");
    openModal = m;
    document.documentElement.style.overflow = "hidden";
    const f = m.querySelector("input, .v95o-paper"); if (f && !isTouch()) f.focus({ preventScroll: true });
  }
  function closeModal() {
    if (!openModal) return;
    openModal.classList.remove("is-on");
    openModal = null;
    document.documentElement.style.overflow = "";
  }
  document.querySelectorAll(".v95o-modal").forEach((m) => {
    m.addEventListener("click", (e) => { if (e.target === m || e.target.closest(".v95o-close")) closeModal(); });
  });
  function fillMemo(key) {
    const src = document.getElementById("v95o-doc-" + key);
    const folder = document.querySelector("#v95o-memo .v95o-folder");
    folder.dataset.tab = LABELS[key].toUpperCase();
    const paper = folder.querySelector(".v95o-paper");
    const d = new Date();
    paper.innerHTML = `<span class="v95o-stamp">${key === "faq" ? "PRIORITY" : "OFFICIAL"}</span><h1>MEMORANDUM</h1>
      <div class="meta"><b>TO:</b><span>All Vapor95 Customers</span><b>FROM:</b><span>Vapor95 Customer Service Dept.</span>
      <b>DATE:</b><span>${d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</span><b>RE:</b><span>${LABELS[key]}</span></div><hr>`;
    const body = document.createElement("div");
    body.innerHTML = src ? src.innerHTML : "<p>File not found.</p>";
    paper.appendChild(body);
    paper.scrollTop = 0;
  }

  // phone: order status lookup. With an endpoint configured it answers on the LCD; otherwise it sends people to
  // their account's order history (Shopify customer accounts show status + tracking there).
  const phoneForm = document.querySelector("#v95o-phone form");
  if (phoneForm) phoneForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    const lcd = document.querySelector("#v95o-phone .v95o-lcd");
    const order = phoneForm.order.value.trim().replace(/^#/, ""), email = phoneForm.email.value.trim();
    if (!order || !email) { lcd.textContent = "PLEASE ENTER YOUR\nORDER # AND EMAIL"; return; }
    lcd.textContent = "DIALING...\nRING RING...";
    await tones(dialDigits(order.slice(0, 10)));
    const url = (g.V95_OFFICE_TRACK_URL || "").trim();
    if (!url) { setTimeout(() => { g.location.href = "/account"; }, 900); return; }
    try {
      const r = await fetch(url + "?order=" + encodeURIComponent(order) + "&email=" + encodeURIComponent(email), { credentials: "same-origin" });
      const j = await r.json();
      lcd.textContent = j.message || "NO ORDER FOUND.\nCHECK YOUR ORDER #\nAND EMAIL.";
      if (j.tracking_url) { const a = document.createElement("a"); a.href = j.tracking_url; a.target = "_blank"; a.rel = "noopener"; a.textContent = "\n► TRACK PACKAGE"; a.style.color = "#1d2a12"; lcd.appendChild(a); }
    } catch (_) { lcd.textContent = "LINE BUSY.\nPLEASE TRY AGAIN."; }
  });

  // ------------------------------------------------------------------ sound: dial tone + touch-tone digits (Web Audio, no files)
  let actx = null;
  function tones(seq) {  // seq: [[freqA, freqB, seconds], ...] ; a null pair = silence
    try {
      actx = actx || new (g.AudioContext || g.webkitAudioContext)();
      if (actx.state === "suspended") actx.resume();
    } catch (_) { return Promise.resolve(); }
    let t = actx.currentTime + 0.02;
    const out = actx.createGain(); out.gain.value = 0.12; out.connect(actx.destination);
    for (const [a, b, dur] of seq) {
      if (a) for (const f of [a, b]) {
        const o = actx.createOscillator(), env = actx.createGain();
        o.frequency.value = f; o.connect(env); env.connect(out);
        env.gain.setValueAtTime(0, t); env.gain.linearRampToValueAtTime(0.5, t + 0.01);
        env.gain.setValueAtTime(0.5, t + dur - 0.015); env.gain.linearRampToValueAtTime(0, t + dur);
        o.start(t); o.stop(t + dur + 0.02);
      }
      t += dur;
    }
    return new Promise((r) => setTimeout(r, (t - actx.currentTime) * 1000 + 60));
  }
  const DTMF = { 1: [697, 1209], 2: [697, 1336], 3: [697, 1477], 4: [770, 1209], 5: [770, 1336], 6: [770, 1477], 7: [852, 1209], 8: [852, 1336], 9: [852, 1477], 0: [941, 1336] };
  const dialDigits = (digits) => [].concat(...String(digits).split("").map((d) => [[...(DTMF[d] || DTMF[0]), 0.085], [null, null, 0.055]]));
  const DIAL_TONE = [[350, 440, 0.85], [null, null, 0.12]];

  // ------------------------------------------------------------------ email: the real Shopify contact form
  const form = root.querySelector(".v95o-mail form") || root.closest("form");   // theme: Shopify's {% form %} wraps the scene
  const dialog = root.querySelector(".v95o-dialog");
  if (form) form.addEventListener("submit", (e) => {
    if (!form.dataset.dialed) {
      e.preventDefault();
      form.dataset.dialed = "1";
      root.querySelector(".v95o-status").textContent = "Dialing up...";
      tones(DIAL_TONE.concat(dialDigits("8269576"))).then(() => (form.requestSubmit ? form.requestSubmit() : form.submit()));
      return;
    }
    delete form.dataset.dialed;
    const subj = form.querySelector("[data-subject]");
    const body = form.querySelector("[name='contact[body]']");
    if (subj && subj.value.trim() && !body.dataset.merged) { body.value = "Subject: " + subj.value.trim() + "\n\n" + body.value; body.dataset.merged = "1"; }
    root.querySelector(".v95o-status").textContent = "Sending message...";
    if (root.hasAttribute("data-demo")) { e.preventDefault(); showDialog("Your message has been sent.\nWe'll get back to you within 24 hours.", false); form.reset(); }
  });
  function showDialog(text, isError) {
    dialog.querySelector("p").textContent = text;
    dialog.classList.toggle("is-error", !!isError);
    dialog.classList.add("is-on");
    root.querySelector(".v95o-status").textContent = isError ? "Message not sent" : "Message sent";
  }
  dialog.querySelector(".ok").addEventListener("click", () => dialog.classList.remove("is-on"));
  root.querySelectorAll(".v95o-clock").forEach((c) => { const t = () => (c.textContent = new Date().toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })); t(); setInterval(t, 30000); });

  build();
  // after a send, Shopify reloads the page with the result: open straight onto the screen and show it
  const posted = root.dataset.posted;
  if (posted) {
    zoomed = true; root.classList.add("is-zoomed"); place(true);
    if (small()) maximize(true);
    if (root._loadCloseup) root._loadCloseup();
    showDialog(posted === "ok" ? "Your message has been sent.\nWe'll get back to you within 24 hours." : root.dataset.errors || "Please check the highlighted fields.", posted !== "ok");
  }
})(window);
